import { createFileRoute } from '@tanstack/react-router';
import { useSessionStore } from '@/store/sessionStore';
import { ProfileOverview } from '../../-components/ProfileOverview';

export const Route = createFileRoute('/(client)/profile/(pages)/overview/')({
  component: OverviewPage,
});

function OverviewPage() {
  const user = useSessionStore(s => s.user);
  if (!user) return null;
  return <ProfileOverview user={user} />;
}
